import { REVIEW_RATING } from "@-/dev.improve.haniverse.lib.cards.user-card.fsrs";

/**
 * Han (汉) one committed review earns. 1 Han is worth ¥1: fares on the China map are priced in
 * real yuan. Kept separate from review recharge points, which happen to share these values today.
 */
export function hanForRating(rating: number): number {
  return rating === REVIEW_RATING.Again ? 1 : 5;
}
